import { Divider, Grid } from "@mui/material";
import React from "react";
import { Header } from "../../Components/Header/Header";
import { useForm } from "react-hook-form";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import NPAReport from "./NpaReports";
import InterestReport from "./InterestReport";
import SanctionedReport from "./SanctionedReport";
import PrincipalReport from "./PrincipalReport";

export const Reports: React.FC<any> = React.memo(
    (props) => {
        const { control } = useForm();
        const tabsData: any[] = [
            { label: "NPA Reports", content: <NPAReport /> },
            {
                label: "Interest Reports",
                content: <InterestReport />
            },
            // { label: "Loan Statements", content: <LoanStatement /> },
            { label: "Principal Reports", content: <PrincipalReport /> },
            { label: "Loan Sanctioned", content: <SanctionedReport /> }
        ];

        return (
            <>
                {" "}
                <Grid item container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
                <Header
                    type="simple"
                    isDivider={true}
                    title="Reports"
                    id={"reports"}
                    headerSx={{ marginTop: 0 }}
                />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <WSTabs
                            id="adasd"
                            control={control}
                            name="tabs"
                            tabs={tabsData}
                            justifyTabs="flex-start"
                        />
                    </Grid>
                </Grid>
            </>
        );
    }
);
